import Box from "./Box";
import Button from "./Button";
import PropTypes from "prop-types";
import React from "react";

function CloseStripe(props) {
  return (
    <Box
      bg="black"
      height="2px"
      width="100%"
      position="absolute"
      top="50%"
      transition="transform 200ms"
      {...props}
    />
  );
}

function CloseButton({ onClick }) {
  return (
    <Button height={27} position="relative" width={27} onClick={onClick}>
      <CloseStripe transform="rotate(45deg)" />
      <CloseStripe transform="rotate(-45deg)" />
    </Button>
  );
}

export default CloseButton;

CloseButton.propTypes = {
  onClick: PropTypes.func.isRequired,
};
